import { render } from "./HospitalFamulaturInformation.vue?vue&type=template&id=aab1610e&scoped=true&ts=true"
import script from "./HospitalFamulaturInformation.vue?vue&type=script&lang=ts"
export * from "./HospitalFamulaturInformation.vue?vue&type=script&lang=ts"

import "./HospitalFamulaturInformation.vue?vue&type=style&index=0&id=aab1610e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab1610e"]])

export default __exports__